module.exports = __webpack_public_path__ + "img/pg.0b07d418.svg";